import React, { useState, useEffect } from 'react';
import { 
  getClienteServicios, 
  guardarClienteServicio, 
  actualizarClienteServicio, 
  eliminarClienteServicio 
} from '../../../services/ClienteServiciosService';
import { getClientes } from '../../../services/ClientesService';
import { getServicios } from '../../../services/ProductService';
import { getPagos, registrarPago, eliminarPago } from '../../../services/PagosHistorialService';

// Estilos
import '../../static/Global.css';
import '../../static/Home.css';
import '../../static/Aside.css';
import '../../static/Flotante.css';
import '../../static/Busqueda.css';

function DashboardClienteServicios() {
  const [asignaciones, setAsignaciones] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("Todos");
  const [loading, setLoading] = useState(true);

  // Modal de Asignación / Edición
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    cliente_id: '',
    servicios_id: '',
    fecha_fin_estimada: '',
    estado: 'En Proceso',
    precio_acordado: '',
    detalles_personalizados: ''
  });

  // Modal de Historial y Registro de Pagos
  const [isPagosModalOpen, setIsPagosModalOpen] = useState(false);
  const [contratoSeleccionado, setContratoSeleccionado] = useState(null);
  const [pagosLista, setPagosLista] = useState([]);
  const [loadingPagos, setLoadingPagos] = useState(false);
  const [pagoFormData, setPagoFormData] = useState({
    monto_pagado: '',
    metodo_pago: 'Yape',
    referencia_operacion: '',
    observaciones: ''
  });

  useEffect(() => {
    cargarDatosIniciales();
  }, []);

  const cargarDatosIniciales = async () => {
    setLoading(true);
    try {
      const [dataAsignaciones, dataClientes, dataServicios] = await Promise.all([
        getClienteServicios(),
        getClientes(),
        getServicios({ all: 'true' })
      ]);
      setAsignaciones(Array.isArray(dataAsignaciones) ? dataAsignaciones : []);
      setClientes(Array.isArray(dataClientes) ? dataClientes : []);
      setServicios(Array.isArray(dataServicios) ? dataServicios : []);
      setLoading(false);
    } catch (error) {
      console.error("Error cargando datos de cliente_servicios:", error);
      setLoading(false);
    }
  };

  const recargarAsignaciones = async () => {
    try {
      const data = await getClienteServicios();
      setAsignaciones(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error recargando asignaciones:", error);
    }
  };

  // --- GESTIÓN DE ASIGNACIONES (CREAR / EDITAR) ---
  const handleSaveAsignacion = async (e) => {
    e.preventDefault();
    try {
      if (formData.id) {
        await actualizarClienteServicio(formData);
        alert("¡Contrato de servicio actualizado con éxito!");
      } else {
        await guardarClienteServicio(formData);
        alert("¡Servicio asignado al cliente con éxito!");
      }
      closeModal();
      recargarAsignaciones();
    } catch (error) {
      alert("Error al procesar: " + error.message);
    }
  };

  const handleDeleteAsignacion = async (id, clienteNombre, servicioNombre) => {
    if (window.confirm(`¿Estás seguro de eliminar el servicio "${servicioNombre}" asignado a ${clienteNombre}? También se eliminará su historial de pagos.`)) {
      try {
        await eliminarClienteServicio(id);
        alert("Asignación eliminada correctamente.");
        recargarAsignaciones();
      } catch (error) {
        alert("Error al eliminar: " + error.message);
      }
    }
  };

  const openModal = (item = null) => {
    if (item) {
      setFormData({
        id: item.id,
        cliente_id: item.cliente_id,
        servicios_id: item.servicios_id,
        fecha_fin_estimada: item.fecha_fin_estimada ? item.fecha_fin_estimada.split('T')[0] : '',
        estado: item.estado || 'En Proceso',
        precio_acordado: item.precio_acordado || '',
        detalles_personalizados: item.detalles_personalizados || ''
      });
    } else {
      setFormData({
        id: '',
        cliente_id: clientes.length > 0 ? clientes[0].id : '',
        servicios_id: servicios.length > 0 ? servicios[0].servicios_id : '',
        fecha_fin_estimada: '',
        estado: 'En Proceso',
        precio_acordado: '',
        detalles_personalizados: ''
      });
    }
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  // --- GESTIÓN DE HISTORIAL DE PAGOS ---
  const openPagosModal = async (contrato) => {
    setContratoSeleccionado(contrato);
    setPagoFormData({
      monto_pagado: '',
      metodo_pago: 'Yape',
      referencia_operacion: '',
      observaciones: ''
    });
    setIsPagosModalOpen(true);
    cargarPagos(contrato.id);
  };

  const closePagosModal = () => {
    setIsPagosModalOpen(false);
    setContratoSeleccionado(null);
  };

  const cargarPagos = async (contratoId) => {
    setLoadingPagos(true);
    try {
      const data = await getPagos(contratoId);
      setPagosLista(Array.isArray(data) ? data : []);
      setLoadingPagos(false);
    } catch (error) {
      console.error("Error cargando pagos:", error);
      setPagosLista([]);
      setLoadingPagos(false);
    }
  };

  const handleRegistrarPago = async (e) => {
    e.preventDefault();
    if (!contratoSeleccionado) return;
    try {
      await registrarPago({
        cliente_servicios_id: contratoSeleccionado.id,
        ...pagoFormData
      });
      alert("¡Abono registrado con éxito!");
      setPagoFormData({
        monto_pagado: '',
        metodo_pago: 'Yape',
        referencia_operacion: '',
        observaciones: ''
      });
      await cargarPagos(contratoSeleccionado.id);
      await recargarAsignaciones();
      // Actualizar saldo del contrato seleccionado
      const dataActualizada = await getClienteServicios();
      const actualizado = dataActualizada.find(c => c.id === contratoSeleccionado.id);
      if (actualizado) setContratoSeleccionado(actualizado);
    } catch (error) {
      alert("Error al registrar pago: " + error.message);
    }
  };

  const handleEliminarPago = async (pagoId) => {
    if (window.confirm("¿Estás seguro de eliminar este pago registrado?")) {
      try {
        await eliminarPago(pagoId);
        alert("Pago eliminado.");
        await cargarPagos(contratoSeleccionado.id);
        await recargarAsignaciones();
        const dataActualizada = await getClienteServicios();
        const actualizado = dataActualizada.find(c => c.id === contratoSeleccionado.id);
        if (actualizado) setContratoSeleccionado(actualizado);
      } catch (error) {
        alert("Error al eliminar pago: " + error.message);
      }
    }
  };

  // Filtrado de la tabla principal
  const asignacionesFiltradas = asignaciones.filter(a => {
    const coincideEstado = filtroEstado === "Todos" || a.estado === filtroEstado;
    const term = busqueda.toLowerCase();
    const clienteCompleto = `${a.cliente_nombres || ''} ${a.cliente_apellidos || ''}`.toLowerCase();
    const dni = a.cliente_dni ? a.cliente_dni.toString() : '';
    const servicio = (a.servicio_nombre || '').toLowerCase();

    const coincideBusqueda = clienteCompleto.includes(term) || dni.includes(term) || servicio.includes(term);
    return coincideEstado && coincideBusqueda;
  });

  const formatearFecha = (str) => {
    if (!str) return 'Sin fecha';
    try {
      return new Date(str).toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch {
      return str;
    }
  };

  const badgeEstado = (estado) => {
    let bg = '#e2e8f0';
    let color = '#334155';
    if (estado === 'En Proceso') { bg = '#e0f2fe'; color = '#0284c7'; }
    else if (estado === 'Finalizado') { bg = '#dcfce7'; color = '#15803d'; }
    else if (estado === 'Cancelado') { bg = '#fee2e2'; color = '#b91c1c'; }
    else if (estado === 'Pausado') { bg = '#fef3c7'; color = '#b45309'; }

    return (
      <span style={{
        padding: '4px 10px',
        borderRadius: '20px',
        fontSize: '0.8rem',
        fontWeight: '600',
        backgroundColor: bg,
        color: color
      }}>
        {estado}
      </span>
    );
  };

  return (
    <section className="main__content">
      <div className="table-container">
        
        {/* ENCABEZADO Y ACCIONES */}
        <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '15px', flexWrap: 'wrap' }}>
          <div>
            <h2 style={{ margin: 0 }}>SERVICIOS DE CLIENTES</h2>
            <small style={{ color: '#64748b' }}>Asignación de proyectos tecnológicos y control de cobros</small>
          </div>

          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
            {/* Filtro por estado */}
            <select 
              value={filtroEstado} 
              onChange={(e) => setFiltroEstado(e.target.value)}
              style={{ height: '40px', borderRadius: '8px', border: '1px solid #ddd', padding: '0 12px', fontSize: '0.9rem' }}
            >
              <option value="Todos">Todos los Estados</option>
              <option value="En Proceso">En Proceso</option>
              <option value="Finalizado">Finalizado</option>
              <option value="Pausado">Pausado</option>
              <option value="Cancelado">Cancelado</option>
            </select>

            {/* Buscador */}
            <div className="search-container" style={{ position: 'relative', width: '280px' }}>
              <i className="fa fa-search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }}></i>
              <input 
                type="text"
                className="search-input"
                placeholder="Buscar cliente, DNI o servicio..."
                style={{ paddingLeft: '35px', width: '100%', borderRadius: '8px', border: '1px solid #ddd', height: '40px' }}
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
              />
            </div>

            <button type="button" className="btn-vender-sidebar" onClick={() => openModal()}>
              <i className="fa fa-plus me-1"></i> Asignar Servicio
            </button>
          </div>
        </div>

        {/* TABLA PRINCIPAL DE ASIGNACIONES */}
        <div className="table-responsive">
          <table className="novatech-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Cliente</th>
                <th>Servicio Contratado</th>
                <th>Precio Acordado</th>
                <th>Pagado</th>
                <th>Saldo</th>
                <th>Estado</th>
                <th>Fecha Entrega</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center', padding: '25px' }}>
                    <i className="fas fa-spinner fa-spin me-2"></i> Cargando servicios de clientes...
                  </td>
                </tr>
              ) : asignacionesFiltradas.length > 0 ? (
                asignacionesFiltradas.map((item) => {
                  const saldo = Number(item.saldo_pendiente || 0);
                  const total = Number(item.precio_acordado || 0);
                  const pagado = Number(item.total_pagado || 0);

                  return (
                    <tr key={item.id}>
                      <td>#{item.id}</td>
                      <td>
                        <strong>{item.cliente_nombres} {item.cliente_apellidos}</strong>
                        <div style={{ fontSize: '0.78rem', color: '#64748b' }}>
                          DNI: {item.cliente_dni} {item.cliente_celular && `• Cel: ${item.cliente_celular}`}
                        </div>
                      </td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          {item.servicio_imagen ? (
                            <img 
                              src={item.servicio_imagen} 
                              alt={item.servicio_nombre} 
                              style={{ width: '38px', height: '38px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #eee' }} 
                            />
                          ) : (
                            <div style={{ width: '38px', height: '38px', borderRadius: '6px', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
                              <i className="fa-solid fa-code"></i>
                            </div>
                          )}
                          <div>
                            <span style={{ fontWeight: '600' }}>{item.servicio_nombre}</span>
                            {item.detalles_personalizados && (
                              <div style={{ fontSize: '0.75rem', color: '#64748b', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={item.detalles_personalizados}>
                                {item.detalles_personalizados}
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                      <td style={{ fontWeight: '600' }}>S/ {total.toFixed(2)}</td>
                      <td style={{ color: '#16a34a', fontWeight: '600' }}>S/ {pagado.toFixed(2)}</td>
                      <td>
                        <span style={{ 
                          fontWeight: '700', 
                          color: saldo <= 0 ? '#16a34a' : '#d97706',
                          backgroundColor: saldo <= 0 ? '#f0fdf4' : '#fffbeb',
                          padding: '3px 8px',
                          borderRadius: '6px'
                        }}>
                          {saldo <= 0 ? 'Cancelado' : `S/ ${saldo.toFixed(2)}`}
                        </span>
                      </td>
                      <td>{badgeEstado(item.estado)}</td>
                      <td style={{ fontSize: '0.85rem' }}>{formatearFecha(item.fecha_fin_estimada)}</td>
                      <td className="actions-cell">
                        {/* Botón Pagos */}
                        <button 
                          className="btn-save" 
                          style={{ padding: '6px 10px', fontSize: '0.8rem', background: '#0284c7' }} 
                          onClick={() => openPagosModal(item)}
                          title="Gestionar Abonos y Pagos"
                        >
                          <i className="fa-solid fa-hand-holding-dollar me-1"></i> Pagos
                        </button>
                        {/* Botón Editar */}
                        <button className="btn-edit" onClick={() => openModal(item)} title="Editar Asignación">
                          <i className="fa fa-edit"></i>
                        </button>
                        {/* Botón Eliminar */}
                        <button 
                          className="btn-delete" 
                          onClick={() => handleDeleteAsignacion(item.id, `${item.cliente_nombres} ${item.cliente_apellidos}`, item.servicio_nombre)} 
                          title="Eliminar Asignación"
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center', padding: '25px', color: '#64748b' }}>
                    {busqueda ? `No se encontraron resultados para "${busqueda}"` : 'No hay servicios asignados a clientes todavía.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>

      {/* ----------------------------------------------------
          MODAL: CREAR / EDITAR ASIGNACIÓN DE SERVICIO
          ---------------------------------------------------- */}
      {isModalOpen && (
        <div className="modal" style={{ display: 'flex' }}>
          <div className="modal-content" style={{ maxWidth: '580px', width: '90%' }}>
            <form onSubmit={handleSaveAsignacion}>
              <h2>{formData.id ? "EDITAR CONTRATO DE SERVICIO" : "ASIGNAR SERVICIO A CLIENTE"}</h2>

              {/* COMBOBOX CLIENTES */}
              <div className="form-group">
                <label>Seleccionar Cliente *</label>
                <select 
                  value={formData.cliente_id} 
                  required 
                  disabled={!!formData.id}
                  onChange={(e) => setFormData({ ...formData, cliente_id: e.target.value })}
                >
                  <option value="">-- Elige un cliente --</option>
                  {clientes.map(c => (
                    <option key={c.id} value={c.id}>
                      {c.nombres} {c.apellidos} (DNI: {c.dni})
                    </option>
                  ))}
                </select>
                {clientes.length === 0 && (
                  <small style={{ color: '#dc2626' }}>No hay clientes registrados en el sistema.</small>
                )}
              </div>

              {/* COMBOBOX SERVICIOS */}
              <div className="form-group">
                <label>Seleccionar Servicio *</label>
                <select 
                  value={formData.servicios_id} 
                  required 
                  disabled={!!formData.id}
                  onChange={(e) => setFormData({ ...formData, servicios_id: e.target.value })}
                >
                  <option value="">-- Elige un servicio --</option>
                  {servicios.map(s => (
                    <option key={s.servicios_id} value={s.servicios_id}>
                      {s.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ display: 'flex', gap: '15px' }}>
                {/* PRECIO ACORDADO */}
                <div className="form-group" style={{ flex: 1 }}>
                  <label>Precio Acordado (S/) *</label>
                  <input 
                    type="number" 
                    step="0.01" 
                    required 
                    placeholder="Ej. 1200.00"
                    value={formData.precio_acordado} 
                    onChange={(e) => setFormData({ ...formData, precio_acordado: e.target.value })} 
                  />
                </div>

                {/* ESTADO */}
                <div className="form-group" style={{ flex: 1 }}>
                  <label>Estado del Servicio</label>
                  <select 
                    value={formData.estado} 
                    onChange={(e) => setFormData({ ...formData, estado: e.target.value })}
                  >
                    <option value="En Proceso">En Proceso</option>
                    <option value="Finalizado">Finalizado</option>
                    <option value="Pausado">Pausado</option>
                    <option value="Cancelado">Cancelado</option>
                  </select>
                </div>
              </div>

              {/* FECHA FIN ESTIMADA */}
              <div className="form-group">
                <label>Fecha Estimada de Entrega</label>
                <input 
                  type="date" 
                  value={formData.fecha_fin_estimada} 
                  onChange={(e) => setFormData({ ...formData, fecha_fin_estimada: e.target.value })} 
                />
              </div>

              {/* DETALLES PERSONALIZADOS */}
              <div className="form-group">
                <label>Especificaciones / Detalles Personalizados</label>
                <textarea 
                  rows="3" 
                  placeholder="Alcance, requerimientos técnicos, tecnologías solicitadas o notas especiales..."
                  value={formData.detalles_personalizados} 
                  onChange={(e) => setFormData({ ...formData, detalles_personalizados: e.target.value })} 
                />
              </div>

              <div className="actions" style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <button type="button" className="btn-cancel" onClick={closeModal}>Cancelar</button>
                <button type="submit" className="btn-save" disabled={!formData.cliente_id || !formData.servicios_id || !formData.precio_acordado}>
                  <i className="fa fa-save me-1"></i> {formData.id ? "Actualizar Contrato" : "Guardar Asignación"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ----------------------------------------------------
          MODAL: HISTORIAL DE PAGOS Y NUEVO ABONO
          ---------------------------------------------------- */}
      {isPagosModalOpen && contratoSeleccionado && (
        <div className="modal" style={{ display: 'flex' }}>
          <div className="modal-content" style={{ maxWidth: '680px', width: '92%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px', marginBottom: '16px' }}>
              <div>
                <h3 style={{ margin: 0, color: '#1e293b' }}>Control de Pagos & Abonos</h3>
                <span style={{ fontSize: '0.85rem', color: '#64748b' }}>
                  Cliente: <strong>{contratoSeleccionado.cliente_nombres} {contratoSeleccionado.cliente_apellidos}</strong> • Servicio: <strong>{contratoSeleccionado.servicio_nombre}</strong>
                </span>
              </div>
              <button 
                type="button" 
                onClick={closePagosModal}
                style={{ background: 'transparent', border: 'none', fontSize: '1.2rem', cursor: 'pointer', color: '#64748b' }}
              >
                &times;
              </button>
            </div>

            {/* RESUMEN DE SALDO */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', background: '#f8fafc', padding: '12px', borderRadius: '8px', marginBottom: '18px' }}>
              <div style={{ textAlign: 'center' }}>
                <small style={{ color: '#64748b' }}>Total Acordado</small>
                <div style={{ fontSize: '1.1rem', fontWeight: '700', color: '#1e293b' }}>
                  S/ {Number(contratoSeleccionado.precio_acordado || 0).toFixed(2)}
                </div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <small style={{ color: '#64748b' }}>Total Abonado</small>
                <div style={{ fontSize: '1.1rem', fontWeight: '700', color: '#16a34a' }}>
                  S/ {Number(contratoSeleccionado.total_pagado || 0).toFixed(2)}
                </div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <small style={{ color: '#64748b' }}>Saldo Pendiente</small>
                <div style={{ fontSize: '1.1rem', fontWeight: '700', color: Number(contratoSeleccionado.saldo_pendiente) <= 0 ? '#16a34a' : '#d97706' }}>
                  S/ {Number(contratoSeleccionado.saldo_pendiente || 0).toFixed(2)}
                </div>
              </div>
            </div>

            {/* FORMULARIO DE NUEVO PAGO */}
            <form onSubmit={handleRegistrarPago} style={{ background: '#f1f5f9', padding: '14px', borderRadius: '8px', marginBottom: '18px' }}>
              <h5 style={{ margin: '0 0 10px 0', fontSize: '0.95rem', color: '#334155' }}>
                <i className="fa-solid fa-plus-circle me-1 text-primary"></i> Registrar Nuevo Abono
              </h5>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1', minWidth: '130px' }}>
                  <input 
                    type="number" 
                    step="0.01" 
                    required 
                    placeholder="Monto (S/) *" 
                    style={{ width: '100%', height: '38px', borderRadius: '6px', border: '1px solid #cbd5e1', padding: '0 10px' }}
                    value={pagoFormData.monto_pagado} 
                    onChange={(e) => setPagoFormData({ ...pagoFormData, monto_pagado: e.target.value })} 
                  />
                </div>
                <div style={{ flex: '1', minWidth: '130px' }}>
                  <select 
                    value={pagoFormData.metodo_pago}
                    onChange={(e) => setPagoFormData({ ...pagoFormData, metodo_pago: e.target.value })}
                    style={{ width: '100%', height: '38px', borderRadius: '6px', border: '1px solid #cbd5e1', padding: '0 10px' }}
                  >
                    <option value="Yape">Yape</option>
                    <option value="Plin">Plin</option>
                    <option value="Transferencia">Transferencia</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Tarjeta">Tarjeta</option>
                  </select>
                </div>
                <div style={{ flex: '1', minWidth: '150px' }}>
                  <input 
                    type="text" 
                    placeholder="Nro. Operación / Ref." 
                    style={{ width: '100%', height: '38px', borderRadius: '6px', border: '1px solid #cbd5e1', padding: '0 10px' }}
                    value={pagoFormData.referencia_operacion} 
                    onChange={(e) => setPagoFormData({ ...pagoFormData, referencia_operacion: e.target.value })} 
                  />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                <input 
                  type="text" 
                  placeholder="Observaciones (Ej: Adelanto 50%, Cuota 2...)" 
                  style={{ flex: 1, height: '38px', borderRadius: '6px', border: '1px solid #cbd5e1', padding: '0 10px' }}
                  value={pagoFormData.observaciones} 
                  onChange={(e) => setPagoFormData({ ...pagoFormData, observaciones: e.target.value })} 
                />
                <button type="submit" className="btn-save" style={{ whiteSpace: 'nowrap', height: '38px', padding: '0 16px' }}>
                  Abonar
                </button>
              </div>
            </form>

            {/* TABLA DE HISTORIAL DE PAGOS */}
            <h5 style={{ margin: '0 0 10px 0', fontSize: '0.95rem', color: '#334155' }}>
              Historial de Pagos Realizados
            </h5>
            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
              <table className="novatech-table" style={{ fontSize: '0.85rem' }}>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Método</th>
                    <th>Referencia</th>
                    <th>Monto</th>
                    <th>Nota</th>
                    <th>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingPagos ? (
                    <tr><td colSpan="6" style={{ textAlign: 'center' }}>Cargando pagos...</td></tr>
                  ) : pagosLista.length > 0 ? (
                    pagosLista.map(p => (
                      <tr key={p.id}>
                        <td>{formatearFecha(p.fecha_pago)}</td>
                        <td><span style={{ fontWeight: '600' }}>{p.metodo_pago}</span></td>
                        <td>{p.referencia_operacion || '-'}</td>
                        <td style={{ color: '#16a34a', fontWeight: '700' }}>S/ {Number(p.monto_pagado).toFixed(2)}</td>
                        <td>{p.observaciones || '-'}</td>
                        <td>
                          <button 
                            onClick={() => handleEliminarPago(p.id)} 
                            style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer' }}
                            title="Eliminar registro de pago"
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="6" style={{ textAlign: 'center', color: '#94a3b8' }}>No se han registrado pagos para este servicio.</td></tr>
                  )}
                </tbody>
              </table>
            </div>

            <div style={{ marginTop: '16px', textAlign: 'right' }}>
              <button type="button" className="btn-cancel" onClick={closePagosModal}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

    </section>
  );
}

export default DashboardClienteServicios;
